import http from "@/api";
export const getProPageApi = (params: { pageNum: number; pageSize: number }) => {
  return http.get("/public/system/product/list", params);
};
export const getProDetailApi = (id: number) => {
  return http.get("/public/system/product/"+id);
};

